import { getMessageFactoryV2 } from "../getCaxaWebSocketV2.js";
const createOrderFileTaskV2 = getMessageFactoryV2({
  code: "CREATE_ORDER_FILE_TASK"
});
export { createOrderFileTaskV2 };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/createOrderFileTaskV2.js